import { SnackbarEventSubscriber } from "./SnackbarEventSubscriber";

export function initializeSubscribers(): void {
  // Initialize the SnackbarEventSubscriber singleton
  SnackbarEventSubscriber.getInstance();

  // Add other subscribers initialization here as needed
}
